import { postAPI } from "../../api/api"
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATEFILTER, REACT_APP_CUSTOMER } from "../../utils/common"


export async function getReferredResources(body: any){
    const Details = postAPI(REACT_APP_CANDIDATEFILTER + '/filter-referral-candidate?page=1&size=200', body)
    return Details
}

export async function submitPaymentofReferral(body: any){
    const Details = postAPI(REACT_APP_CANDIDATE + '/referral-payment', body)
    return Details
}
  

